export default "__VITE_ASSET__98c2b1c8__"